import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export const formas_de_pagamento_module = {
  state,
  actions,
  mutations,
  getters
};

export default {};
